import React, { useEffect } from 'react'
import { TextField, ReferenceManyField, FunctionField } from 'react-admin'
import { DateField, DataGrid } from 'theme/components'
import { formatPrice } from 'utils/string'
import { useCustomer } from 'components/pages/customer/contexts/customer'

export const ShortAdyenTransactionsList = ({
  ListStats,
  setTotal,
  ...props
}) => {
  const { customerId } = useCustomer()

  useEffect(() => {
    setTotal(0)
  }, [setTotal])

  return (
    <ReferenceManyField
      addLabel={false}
      reference="transactions"
      source="id"
      target=""
      filter={{
        'payment.customer.id': customerId,
        properties: ['createdAt', 'amount', 'currency'],
        'properties[payment][status]': ['name'],
      }}
      {...props}
    >
      <DataGrid showEmpty emptyText="No options available" rowClick={() => {}}>
        {ListStats}
        <FunctionField
          label="Amount"
          source="amount"
          render={(record) => {
            const { amount, currency } = record

            return formatPrice(amount / 100, currency?.code)
          }}
        />
        <TextField source="payment.status.name" label="Status" />
        <DateField source="createdAt" label="Created at" />
      </DataGrid>
    </ReferenceManyField>
  )
}
